export const AllAvailableFeatureFlagsName = {
	// AC - 360x
	FEATURE_FLAG_SHOW_ESG_INDUSTRY_INVOLVEMENT_COMPONENT: '360: ESG Industry Involvement Component', // owner: wkennerl
	FEATURE_FLAG_SHOW_ESG_HOLDINGS_TABLE_COMPONENT: '360: ESG Holdings Table Component', // owner: wkennerl

	// Investment Quality
	FEATURE_FLAG_ENABLE_IQ_WATCHLIST: 'IQ: Watchlist', // owner: agrigore

	// Nile - P360
	FEATURE_FLAG_ENABLE_EQUITY_STYLE_BOX: 'P360: Equity Style Box', // owner: dcostea

	// Portfolio Editor
	FEATURE_FLAG_ENABLE_BULK_PORTFOLIO_IMPORT: 'PE: Bulk Portfolio Import', // owner: libian

	// Shared
	FEATURE_FLAG_OPTIMISE_PERFORMANCE_API_CALLS: 'Shared: Optimise Performance API calls', // owner: agrigore

	// Platform
	FEATURE_FLAG_EVENTS_LOGGING: 'Platform: Events Logging' // owner: dextga1
};

export enum AllAvailableFeatureFlags {
	// AC - 360
	FEATURE_FLAG_SHOW_ESG_INDUSTRY_INVOLVEMENT_COMPONENT = 'FEATURE_FLAG_SHOW_ESG_INDUSTRY_INVOLVEMENT_COMPONENT',
	FEATURE_FLAG_SHOW_ESG_HOLDINGS_TABLE_COMPONENT = 'FEATURE_FLAG_SHOW_ESG_HOLDINGS_TABLE_COMPONENT',

	// Investment Quality
	FEATURE_FLAG_ENABLE_IQ_WATCHLIST = 'FEATURE_FLAG_ENABLE_IQ_WATCHLIST',

	// Nile - P360
	FEATURE_FLAG_ENABLE_EQUITY_STYLE_BOX = 'FEATURE_FLAG_ENABLE_EQUITY_STYLE_BOX',

	// Portfolio Editor
	FEATURE_FLAG_ENABLE_BULK_PORTFOLIO_IMPORT = 'FEATURE_FLAG_ENABLE_BULK_PORTFOLIO_IMPORT',

	// Shared
	FEATURE_FLAG_OPTIMISE_PERFORMANCE_API_CALLS = 'FEATURE_FLAG_OPTIMISE_PERFORMANCE_API_CALLS',

	// Platform
	FEATURE_FLAG_EVENTS_LOGGING = 'FEATURE_FLAG_EVENTS_LOGGING'
}
